import Flex from 'antd/lib/flex'
import Select from 'antd/lib/select'
import dayjs from 'dayjs'
import styles from './TaskNavigator.module.less'
import { useCallback, useMemo } from 'react'

export type TaskNavigatorProps = {
    taskData: {
        submittedAt?: string
        stepName: string
        taskId: string
        isCurrentUserStep: boolean
    }[]
}

export const TaskNavigator = (props: TaskNavigatorProps) => {
    const getOptionRenderComponent = useCallback(
        (option: {
            data: {
                key: string
                label: string
                submittedAt: string
                value: string
            }
        }) => {
            return (
                <Flex justify="space-between" gap={20}>
                    <div className={styles['current-task-view-title']}>{option.data.label}</div>
                    <div className={styles['current-task-view-submittedAt']}>
                        {option.data.submittedAt}
                    </div>
                </Flex>
            )
        },
        []
    )

    const options = useMemo(
        () =>
            props.taskData.map(task => ({
                key: task.taskId,
                label: `${task.stepName.toUpperCase()}${task.isCurrentUserStep ? ' (you)' : ''}`,
                value: task.taskId,
                submittedAt: task.submittedAt
                    ? dayjs(task.submittedAt).format('HH:mm, Do MMM YYYY')
                    : '',
            })),
        [props.taskData]
    )

    return (
        <Flex gap={6} justify="center" align="center">
            <div className={styles['current-task-view-label']}>Current View:</div>
            <Select
                options={options}
                optionRender={option => getOptionRenderComponent(option)}
                value={window.location.pathname.split('/')[2]}
                style={{ width: 200 }}
                dropdownStyle={{
                    padding: '0px',
                    borderRadius: '4px',
                    border: '1px solid #F7F7F8',
                }}
                popupMatchSelectWidth={false}
                onChange={value => {
                    window.location.href = `/preview-task/${value}`
                }}
            />
        </Flex>
    )
}
